import styled from "styled-components";
import { Link } from "react-router-dom";

export const MainWrapper = styled.section`
  padding: 0rem 3rem 0.5rem 3rem;
  display: flex;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
  background: #fafcfd;
  @media screen and (max-width: 1200px) {
    padding: 0px 30px 5px 30px;
  }
`;
export const LearningMainWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const CenterHeader = styled.div`
  align-items: center;
  display: flex;
  height: 10rem;
  border-bottom: 0.1rem solid #e6e6e6;
  padding: 3rem 0;
  @media screen and (min-width: 1915px) {
      height: 13.5rem;
      padding: 4rem 0;
  }
  @media screen and (max-width: 1200px) {
      height: 59px;
  }

`;

export const LHeading = styled.h1`
  font-weight: 600;
  font-size: 3.2rem;
  line-height: 3.9rem;
  color: #0d2c54;
  @media screen and (min-width: 1915px) {
    font-size: 4.2rem;
  }
  @media screen and (max-width: 1200px) {
    font-size: 22px;
  }
 
`;

export const LearningContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  @media screen and (max-width: 743px) {
    flex-direction: column;
  }
`;

export const LeftLearningWrapper = styled.div`
  width: 100%;
  height: 100%;
  width: calc(100% - 45rem);
  padding-right: 3rem;
  @media screen and (min-width: 1915px) {
    width: calc(100% - 51rem);
  }
  @media screen and (max-width: 1200px) {
    width: calc(100% - 279px);
    padding-right: 29px;
  }
  @media screen and (max-width: 1024px) {
    padding-right: 19px;
    width: calc(100% - 244px);
  }
  @media screen and (max-width: 743px) {
    width: 100%;
  }
`;

export const LeftHeader = styled.header`
  padding-top: 3rem;
  border-bottom: 0.1rem solid #E5F0FF;
  padding-bottom: 1.2rem;
  @media screen and (min-width: 1915px) {
      padding-top: 4rem;
      padding-bottom: 1.7rem;
      height: 8.3rem;
  }
  @media screen and (max-width: 1200px) {
    padding-bottom: 12px;
    padding-top: 30px;
  }
`;

export const ArticleTab = styled.button`
  margin-right: 2.2rem;
  @media screen and (min-width: 1915px) {
    margin-right: 3.4rem;
   }
  @media screen and (max-width: 1024px) {
    margin-right: 23px;
  }
  &:last-child{
    margin-right: 0px;
  }
  span {
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 1.9rem;
    color: #7D868C;
    position: relative;
    padding: 0 1rem 1.2rem 1rem;
    @media screen and (min-width: 1915px) {
      font-size: 2.1rem;
      padding-bottom: 1.7rem;
    }
    @media screen and (max-width: 1200px) {
      font-size: 16px;
      padding: 0 10px 12px 10px;
      line-height: 19px;
    }
    @media screen and (max-width: 1024px) {
      font-size: 14px;
      padding: 0 3px 12px 3px;
    }
    @media screen and (max-width: 576px) {
      font-size: 12px;
      padding-bottom: 14px;
   }
   @media screen and (max-width: 446px) {
      font-size: 10px;
      padding-bottom: 16px;
   }
 }

  &.active {
    cursor: default;
    span {
      color: #0D2C54;
      &::after {
        content: " ";
        width: 100%;
        height: 0.1rem;
        top: 100%;
        left: 0;
        background-color:  #0D2C54;
        position: absolute;
      }
    }
    &:hover{
      span{
        color: #0d2c54;
        &::after {
          background-color: #0d2c54;
        }
      }
     
    }
  }
  &:hover {
      span {
        color: #118acb;
        &::after {
          content: " ";
        width: 100%;
        height: 0.1rem;
        top: 100%;
        left: 0;
        background-color: #118acb;
        position: absolute;
        }
      }
    }
`;
export const MethologyTab = styled.div`
  display: ${({ open }) => (open ? "" : "none")};
`;

export const IndustryStudiesTab = styled.div`
  display: ${({ open }) => (open ? "" : "none")};
`;

export const WebcastTab = styled.div`
  display: ${({ open }) => (open ? "" : "none")};
`;

export const LearnCardContainer = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  @media screen and (max-width: 1200px) {
    margin-top: 10px;
    margin-left: -15px;
    margin-right: -15px;
  }
`;

export const LearnCardCol = styled.div`
  width: 50%;
  padding: 1.5rem;
  @media screen and (max-width: 1200px) {
    padding: 10px 15px;
  }
  @media screen and (max-width: 1125px) {
    width: 100%;
    padding: 10px 40px 10px 15px;
  }
`;
export const WebcastButton = styled.button`
   background: #ffffff;
  border: 0.1rem solid #f0f0f0;
  border-radius: 0.6rem;
  width: 100%;
  min-height: 8.9rem;
  display: flex;
  align-items: center;
  padding: 1rem;
  transition: 0.25s ease-in;
  &:hover {
    background: #ffffff;
    border: 0.1rem solid #118acb;
    border-radius: 0.6rem;
    box-shadow: 0rem 0rem 1.8rem rgba(77, 77, 79, 0.25);
    transition: 0.25s ease-in;
  }
  .card_img {
      width: 82px;
      height: 64px;
      @media screen and (min-width: 1915px) {
        width: 12.8rem;
        height: 10rem;
     }
      @media screen and (max-width: 1200px) {
        width: 60px;
        height: 46px;

      }
    img {
      @media screen and (min-width: 1915px) {
        width: 12.8rem;
        height: 10rem;
     }
      @media screen and (max-width: 1200px) {
        width: 60px;
        height: 46px;

      }
     
    }
  }
  @media screen and (min-width: 1915px) {
      min-height: 12rem;
  }
  @media screen and (max-width: 1200px) {
     min-height: 67px;
     padding: 10px ;
  }

`;
export const LearnCard = styled(Link)`
  background: #ffffff;
  border: 0.1rem solid #f0f0f0;
  border-radius: 0.6rem;
  width: 100%;
  min-height: 8.9rem;
  display: flex;
  align-items: center;
  padding: 1rem;
  transition: 0.25s ease-in;
  &:hover {
    background: #ffffff;
    border: 0.1rem solid #118acb;
    border-radius: 0.6rem;
    box-shadow: 0rem 0rem 1.8rem rgba(77, 77, 79, 0.25);
    transition: 0.25s ease-in;
  }
  .card_img {
      width: 82px;
      height: 64px;
      @media screen and (min-width: 1915px) {
        width: 12.8rem;
        height: 10rem;
     }
      @media screen and (max-width: 1200px) {
        width: 60px;
        height: 46px;

      }
    img {
      @media screen and (min-width: 1915px) {
        width: 12.8rem;
        height: 10rem;
     }
      @media screen and (max-width: 1200px) {
        width: 60px;
        height: 46px;

      }
     
    }
  }
  @media screen and (min-width: 1915px) {
      min-height: 12rem;
  }
  @media screen and (max-width: 1200px) {
     min-height: 67px;
     padding: 10px ;
  }
`;

export const LCardDetails = styled.div`
  padding-left: 2rem;
  @media screen and (min-width: 1915px) {
    padding-left: 2.6rem;
  }
  @media screen and (max-width: 1200px) {
    padding-left: 10px;
    }
  h1 {
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 130%;
    color: #4d4d4f;
    padding-bottom: 0.8rem;
    @media screen and (min-width: 1915px) {
      font-size: 2rem;
      padding-bottom: 1.3rem;
   }
    @media screen and (max-width: 1200px) {
      font-size: 14px;
      padding-bottom: 6px;
    }
  }
  p {
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 130%;
    color: #4d4d4f;
    &.cpg-txt {
      font-weight: 500;
      font-size: 1.4rem;
      line-height: 2.2rem;
      color: #4d4d4f;
      @media screen and (min-width: 1915px) {
      font-size: 1.8rem;
      line-height: 2.4rem;
   }
      @media screen and (max-width: 1200px) {
      font-size: 12px;
      }
    }
    @media screen and (min-width: 1915px) {
      font-size: 1.6rem;
   }
    @media screen and (max-width: 1200px) {
      font-size: 10px;
    }
  }
`;

export const RightLearningWrapper = styled.div`
  width: 45rem;
  border-left: 0.1rem solid #e6e6e6;
  padding-left: 3rem;
  @media screen and (min-width: 1915px) {
    width: 60rem;
    padding-left: 5rem;
  }
  @media screen and (max-width: 1200px) {
    width: 348px;
    padding-left: 30px;
  }
  @media screen and (max-width: 1024px) {
    width: 279px;
  }
  @media screen and (max-width: 743px) {
    border-left: none;
    width: 100%;
    padding-left: 0px;
  }
`;
export const RightHeader = styled.div`
  padding-top: 3rem;
  border-bottom: 0.1rem solid #E5F0FF;
  padding-bottom: 1.2rem;
  cursor: default;
  @media screen and (min-width: 1915px) {
      padding-top: 4rem;
      padding-bottom: 1.7rem;
      height: 8.3rem;
  }
  @media screen and (max-width: 1200px) {
    padding-top: 30px;
    padding-bottom: 12px;
  }
  span {
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 1.9rem;
    color: #0d2c54;
    position: relative;
    padding: 0 1rem 1.2rem 1rem;
    @media screen and (min-width: 1915px) {
      font-size: 2.1rem;
      padding-bottom: 1.7rem;
  }
    @media screen and (max-width: 1200px) {
      font-size: 16px;
      padding: 0 10px 12px 10px;
      line-height: 19px;
    }
    @media screen and (max-width: 1024px) {
      font-size: 14px;
    }
    &::after {
      content: " ";
      width: 100%;
      height: 0.1rem;
      top: 100%;
      left: 0;
      background-color: #0d2c54;
      position: absolute;
      @media screen and (max-width: 1024px) {
        height: 1px;
    }
    }
  }
  &.active{
    span {
      color: #118acb;
      &::after {
        background-color: #118acb;
      }
    }
  }
  /* &:hover {
    span {
      color: #118acb;
      &::after {
        background-color: #118acb;
      }
    }
  } */
  
`;

export const RightCardContainer = styled.div`
  padding-top: 3rem;
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 1915px) {
    padding-top: 5rem;
  }
  @media screen and (max-width: 1200px) {
    padding-top: 30px;
  }
`;
export const PlatformCardCol = styled.div`
  padding-bottom: 3rem;
  margin-right: -1.5rem;
  @media screen and (min-width: 1915px) {
      padding-bottom: 5rem;
  }
  @media screen and (max-width: 1200px) {
    padding-bottom: 30px;
   margin-right: -15px;
  }
`;

export const PlatformDetail = styled.div`
  padding-left: 2rem;
  max-width: 100%;
  @media screen and (min-width: 1915px) {
    padding-left: 3rem;
  }
  @media screen and (max-width: 1200px) {
    padding-left: 10px;
    }
  h1 {
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2rem;
    color: #4d4d4f;
    margin-bottom: 1rem;
    display: inline-block;
    border-bottom: 0.1rem solid transparent;
    &.loss-text{
      margin-right: 20px;
      @media screen and (min-width: 1915px) {
        margin-right: 30px;
    }
    }
    @media screen and (min-width: 1915px) {
      font-size: 2.1rem;
      margin-bottom: 1.3rem;
    }
    @media screen and (max-width: 1200px) {
      font-size: 14px;
      margin-bottom: 6px ;
      line-height: 20px;
    }
  }
  p {
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 130%;
    color: #7d868c;
    text-align: left;
    @media screen and (min-width: 1915px) {
      font-size: 1.6rem;
    }
    @media screen and (max-width: 1200px) {
      font-size: 10px;
    }
   
  }
`;

export const PlatformCard = styled(Link)`
  display: flex;
  align-items: center;
  //padding: 1rem;
  border-radius: 0.6rem;
  width: 100%;
  .pcard-img {
    @media screen and (min-width: 1915px) {
          width: 10rem;
          height: 10rem;
      }
    img {
      border-radius: 50%;
      border: 0.1rem solid transparent;
      width: 80px;
        height: 80px;
        @media screen and (min-width: 1915px) {
          width: 10rem;
          height: 10rem;
      }
      @media screen and (max-width: 1200px) {
        width: 60px;
        height: 60px;
      }
      @media screen and (max-width: 1024px) {
        width: 50px;
        height: 50px;
      }
    }
  }
  &:hover {
    background: #fafcfd;
    border-radius: 0.6rem;
    .pcard-img {
      img {
        background: #e5f5f1;
        border: 0.1rem solid #118ACB;
        transition: 0.25s ease-in;
        &.smart-img{
          border: 0.1rem solid #8686DF;
        }
        &.training-img{
          border: 0.1rem solid #45B097;
        }
      }
    }
    ${PlatformDetail} {
      h1 {
        color: #118acb;
       border-bottom: 0.1rem solid #118ACB;
        transition: 0.25s ease-in;
      }
      p {
        color: #118acb;
      }
    }
  }
`;

/*---------- Free Consulation Button for Educate Training ---------------*/

export const  FreeCounsulationButton = styled.button`
    background: linear-gradient(91.83deg, #139BD6 12.22%, #0789CF 100.41%);
    border-radius: 3rem;
    width: 20rem;
    height: 4.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 2rem;
    display: none;
    @media screen and (max-width: 1200px) {
        width: 164px;
        height: 36px;
      }
    span{
      font-weight: 600;
      font-size: 1.4rem;
     // line-height: 150%;
      color: #FFFFFF;
      @media screen and (max-width: 1200px) {
        font-size: 12px;
      }
     
    }
`;